import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { map, Observable, take, of, switchMap, catchError } from 'rxjs';
import { RoleService } from '@app/portal/organisation-roles/role.service';
import { OrgService } from '@app/portal/selectOrganisation/service/org.service';

@Component({
    selector: 'app-ai-chatbot',
    templateUrl: './ai-chatbot.component.html',
    styleUrls: ['./ai-chatbot.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class AiChatbotComponent implements OnInit {
    isHover = false;
    showChatbot = false;
    chatbotEnabled = false;
    chatbotUrl: SafeResourceUrl;

    constructor(
        private sanitizer: DomSanitizer,
        private roleService: RoleService,
        private orgService: OrgService
    ) { }

    ngOnInit() {
        this.loadPermissions();
    }

    loadPermissions() {
        const orgId = localStorage.getItem('tokenOrganisationID');
        if (!orgId) {
            this.chatbotEnabled = false;
            return;
        }

        this.orgService.listUserOrgs({
            pagination: { first: 1 },
            filters: { id: orgId }
        }).pipe(
            map(res =>
                Array.isArray(res)
                    ? res[0]?.organisationUser?.roleID
                    : res?.organisations?.[0]?.organisationUser?.roleID
            ),
            switchMap(roleID => roleID ? this.roleService.getOrganisationRolePermissionsById(roleID) : of([])),
            map(perms => perms.some(p => String(p.name) === 'AiChatbot')),
            take(1),
            catchError(() => of(false))
        ).subscribe(enabled => this.chatbotEnabled = enabled);
    }

    private getChatbotUrlWithToken(): SafeResourceUrl {
        const baseUrl = 'https://ai.roadcast.net';
        const storedToken = localStorage.getItem('auth_token');
        const authToken = storedToken?.startsWith('Bearer ') ? storedToken.slice(7) : storedToken;

        const params = new URLSearchParams({
            token: authToken,
        });

        const urlWithToken = `${baseUrl}?${params.toString()}`;

        return this.sanitizer.bypassSecurityTrustResourceUrl(urlWithToken);
    }

    openChatbot() {
        this.chatbotUrl = this.getChatbotUrlWithToken();
        this.showChatbot = true;
    }

    closeChatbot() {
        this.showChatbot = false;
    }
}
